import { statementSteps } from 'components/tutorial/Steps';
import { TutorialComponent } from 'components/tutorial/TutorialComponent';
import { StatementManagement } from 'pages/statements';
import { useTutorialStore } from 'store/tutorialStore';
import {
  mockPayors,
  mockProviders,
  mockStatuses,
  mockTariffs,
  mockStatements,
} from 'test-fixtures/mocks/frontend';

export const TutorialStatementManagement: React.FC = () => {
  const { isTutorialActive } = useTutorialStore();

  return (
    <>
      {isTutorialActive && (
        <TutorialComponent
          steps={statementSteps}
          page="statements"
          waitForSelector={'[data-testid="statementManagement-table"]'}
        />
      )}
      <StatementManagement
        statements={mockStatements}
        payors={mockPayors}
        providers={mockProviders}
        statuses={mockStatuses}
        tariffs={mockTariffs}
        isLoading={false}
        isError={false}
        errorMessage={''}
      />
    </>
  );
};
